import { TFeaturedComponent } from "src/Featuresmap";
import { BaseForm, TFormType } from "./BaseForm";

type TSettingsProps = {
	size?: Parameters<typeof BaseForm>[0]["size"];
	appearance?: Parameters<typeof BaseForm>[0]["appearance"];
	target_id: any;
	target_type: TFormType;
	type?: Parameters<typeof BaseForm>[0]["type"];
};
export const Settings: TFeaturedComponent<TSettingsProps> = ({ target_id, target_type, type, appearance, size }) => {
	return <BaseForm size={size} appearance={appearance} target_id={target_id} target_type={target_type} type={type ?? "common"} />;
};

Settings.feature = "settings";
